import React from 'react';
import { Shimmer, ShimmerElementType, mergeStyles } from '@fluentui/react';

const wrapperClass = mergeStyles({
  padding: 2,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
      border: 'none',
    },
  },
});

export const radiusShimmerElement = [
  { type: ShimmerElementType.line, width: 20, height: 20 },
  { type: ShimmerElementType.gap, width: 5 },
  { type: ShimmerElementType.line, height: 16, width: 300 },
  { type: ShimmerElementType.gap, height: 20, width: '100%' },
];

export const SectionShimmer = () => (
  <div>
    <Shimmer shimmerElements={radiusShimmerElement} />
    <Shimmer shimmerElements={[{ type: ShimmerElementType.gap, width: '100%', height: 12 }]} />
    <Shimmer shimmerElements={radiusShimmerElement} />
  </div>
);

const audienceShimmerElement = [
  { type: ShimmerElementType.line, width: 200, height: 100 },
  { type: ShimmerElementType.gap, width: '2%', height: 100 },
  { type: ShimmerElementType.line, width: 200, height: 100 },
  { type: ShimmerElementType.gap, width: '100%', height: 100 },
];

const shimmerWithElementFirstRow = [
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
];
const shimmerWithElementSecondRow = [
  { type: ShimmerElementType.circle, height: 24 },
  { type: ShimmerElementType.gap, width: '2%', height: 24 },
  { type: ShimmerElementType.line, height: 16, width: '20%' },
  { type: ShimmerElementType.gap, width: '100%', height: 16 },
];

export const AudienceSignalShimmer = () => (
  <div>
    <Shimmer shimmerElements={audienceShimmerElement} />
  </div>
);

const singleLineShimmer = [
  { type: ShimmerElementType.line, width: 200, height: 50 },
];

export const SingleLineShimmer = () => (
  <div>
    <Shimmer shimmerElements={singleLineShimmer} />
  </div>
);

export const AdScheduleShimmer = () => (
  <div className={wrapperClass}>
    <Shimmer shimmerElements={shimmerWithElementFirstRow} />
    <Shimmer shimmerElements={shimmerWithElementFirstRow} />
    <div style={{ marginTop: 50 }}>
      <Shimmer width={100} />
      <br />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
    </div>
    <div style={{ marginTop: 50 }}>
      <Shimmer width={100} />
      <br />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
    </div>
  </div>
);

export const RadioShimmer = () => (
  <div>
    <Shimmer shimmerElements={[
        { type: ShimmerElementType.circle, height: 24 },
        { type: ShimmerElementType.gap, width: 20 },
        { type: ShimmerElementType.line, width: 300 },
        { type: ShimmerElementType.gap, width: '100%' },
      ]}
    />
    <Shimmer shimmerElements={[
        { type: ShimmerElementType.circle, height: 24 },
        { type: ShimmerElementType.gap, width: 20 },
        { type: ShimmerElementType.line, width: 300 },
        { type: ShimmerElementType.gap, width: '100%' },
      ]}
    />
  </div>
);

export const StoreSelectorShimmer = () => (
  <div>
    <Shimmer
      shimmerElements={[
        { type: ShimmerElementType.line, width: '100%' },
      ]}
    />
    <br />
    <Shimmer
      shimmerElements={[
        { type: ShimmerElementType.line, width: 200 },
        { type: ShimmerElementType.gap, width: '100%' },
      ]}
    />
    <br />
    <Shimmer
      shimmerElements={[
        { type: ShimmerElementType.line, width: '100%' },
      ]}
    />
    <Shimmer
      shimmerElements={[
        { type: ShimmerElementType.line, width: '100%' },
      ]}
    />
    <br />
    <Shimmer
      shimmerElements={[
        { type: ShimmerElementType.line, width: 200 },
        { type: ShimmerElementType.gap, width: '100%' },
      ]}
    />
    <br />
    <Shimmer
      shimmerElements={[
        { type: ShimmerElementType.line, width: 50, height: 50 },
        { type: ShimmerElementType.gap, width: 20 },
        { type: ShimmerElementType.line, width: 200 },
        { type: ShimmerElementType.gap, width: '100%' },
      ]}
    />
  </div>
);
